import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TrixComponent } from './trix.component';

@NgModule({
    declarations: [TrixComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,

    ],
    exports: [TrixComponent],
    providers: [],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class TrixModule { }

